/**
 * Created by Pradeep Kumar on 05/21/2019.
 */

import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {TombOfNefertitiAnimatedWinlineController} from "../animatedwinlines/TombOfNefertitiAnimatedWinlineController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class TombOfNefertitiBetLineWinIndividualWPController extends BetLineWinIndividualWPController {

    private _layer: PIXI.Container;
    private _animItems: PIXI.Sprite[] = [];

    constructor(config: IIndividualWinPresentationConfig, name?: string, tweakEnabled?: boolean) {
        super(config, name, tweakEnabled);

        this._layer = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.SYMBOLS_ANIMATION.name);

        (this._animItems as any) = this._layer.children;
    }

    protected getLineAnimation(betLineWinData: IBetLineWinData): Timeline {
        const timeline: TimelineLite = new TimelineLite(),
            startDelay: number = 0.4,
            numOfRows: number = 3,
            symId: number = 0;

        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiAnimatedWinlineController.PLAY_INDIVIDUAL_WINLINE, betLineWinData.betLineIndex, true, this._betWinsData!.length === 1)); // overridden here to call individual betline animation as per this game.
        }, startDelay);

        for (let i: number = 0; i < betLineWinData.nrOfSymbols; i++) {
            const symbol = Reels.getSymbol((i * numOfRows) + betLineWinData.betLine[i], symId); // overridden here to work as per 15 reels.
            if (symbol) {
                this.addSymbolWinAnimationToTimeline(betLineWinData, timeline, (this._config.symbolTimeOffsetCalculator(timeline.totalDuration(), i, betLineWinData.betLine[i])) + startDelay, symbol, i, betLineWinData.betLine[i]);
                if (this._winSymbols.indexOf(symbol) === -1) {
                    this._winSymbols.push(symbol);
                }
            }
        }

        return timeline;
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData: IBetLineWinData, timeline: gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax, startTime: number, symbol: StateReelSymbol, reelId: number, symbolId: number): void {
        let symName: string = symbol.symName,
            item: PIXI.Sprite;

        super.addSymbolWinAnimationToTimeline(betLineWinData, timeline, startTime, symbol, reelId, symbolId);

        if (symName.indexOf("L") !== -1) {
            const duration: number = 27 / 30;

            item = this._animItems[reelId * 3 + symbolId];
            item.visible = true;

            item.texture = GameResources.getTextures(`${symName}/${symName}-H`)[0];
            item.alpha = 0;

            timeline.add(TweenLite.to(item, duration, {alpha: 1}), 0);
            timeline.add(TweenLite.to(item, duration, {alpha: 0}), duration);
        }
    }

    protected stopWinPresentation(isAborted: boolean): void {
        super.stopWinPresentation(isAborted);

        let item: PIXI.Sprite;

        for (let i: number = 0; i < this._animItems.length; ++i) {
            item = this._animItems[i];

            TweenLite.killTweensOf(item);
            item.visible = false;
        }

        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiAnimatedWinlineController.CLEAN_UP_ANIMATED_WINLINE));
    }

    protected hasWin(): boolean {
        let retVal: boolean = super.hasWin();

        // #330 fix
        return retVal && (this._gameData!.mode.indexOf("FREESPIN") === -1 && this._gameData!.nextMode === GameMode.NORMAL);
    }
}